<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <section class="section-hotels-edit-rooms">
            <div class="hotels-wrap">
              <HotelsSideMenu />
              <div class="hotels-content">
                <div class="lds-ring" v-if="!isLoad">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div class="hotel-inner" v-if="isLoad">
                  <h1 class="hotel-inner__title">{{ hotel.names.EN }}</h1>
                  <form>
                    <div class="page-title page-hotel-title">
                      <div class="inline-flex-center">
                        <h2>Hotel</h2>
                        <div class="rating hotel-rating">
                          <div class="" v-if="hotel.rating === '0' || hotel.rating === 0">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '0.5' || hotel.rating === 0.5">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="6" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-6" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '1' || hotel.rating === 1">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '1.5' || hotel.rating === 1.5">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="6" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-6" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '2' || hotel.rating === 2">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '2.5' || hotel.rating === 2.5">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="6" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-6" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '3' || hotel.rating === 3">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '3.5' || hotel.rating === 3.5">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="6" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-6" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '4' || hotel.rating === 4">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="0" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-12" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '4.5' || hotel.rating === 4.5">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="6" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="-6" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                          <div class="" v-if="hotel.rating === '5' || hotel.rating === 5">
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                            <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_1774_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="32" height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514"/>
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect x="12" width="12" height="12" fill="#CCCCCC"/>
                                <rect x="0" width="12" height="12" fill="#EB9514"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div class="select-rating select-rating-star-hotel">
                          <div class="form-control-group">
                            <div :class="['select-wrapper', {'is-active' : selects.star}]"
                                 @click="openSelect('star')">
                              <div class="select-trigger">
                                <span class="select-trigger__name">{{ hotel.rating ? hotel.rating : '' }}
                              </span>
                                <span class="select-trigger__icon">
                                  <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                  </svg>
                                </span>
                              </div>
                              <div class="select-body">
                                <div class="select-inner">
                                  <div v-for="(item, index) in data.starts" :key="index"
                                       :class="['select-option', { 'is-selected': hotel.rating && item.id === hotel.rating.id }]"
                                       @click="hotel.rating = item.star;isEditFlag = true">
                                    <span class="select-option__name">{{ item.star }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="hotel-status-controls">
                        <div class="switch">
                          <span class="switch__label">Active</span>
                          <label class="switch-label"><input type="checkbox"
                                                             v-model="hotel.active"
                                                             @click="isEditFlag = true">
                            <span class="switch-inp"></span>
                          </label>
                        </div>
                        <div class="switch hotel-best-price-control">
                          <img class="hotel-best-price-badge"
                               src="/images/useful/svg/hotel-best-price.svg"
                               alt="Best Price">
                          <label class="switch-label"><input type="checkbox"
                                                             v-model="hotel.bestPrice"
                                                             aria-label="Best Price"
                                                             @click="isEditFlag = true">
                            <span class="switch-inp"></span>
                          </label>
                        </div>
                        <div class="switch hotel-low-priority-control">
                          <img class="hotel-low-priority-badge"
                               src="/images/useful/svg/hotel-low-priority.svg"
                               alt="Low Priority">
                          <label class="switch-label"><input type="checkbox"
                                                             v-model="hotel.lowPriority"
                                                             aria-label="Low Priority"
                                                             @click="isEditFlag = true">
                            <span class="switch-inp"></span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-control-group form-control-group_1" style="margin-bottom: 16px;">
                      <span class="form-control-label">Sort priority</span>
                      <div class="form-control-wrap">
                        <input type="number" v-model="hotel.sortPriority"
                               class="form-control"
                               @focus="isEditFlag = true">
                      </div>
                    </div>

                    <div class="form-control-group form-control-group_htl form-control-group__preferred-partner"><span
                        class="form-control-label">Hotel Name (EN)</span>
                      <div :class="['form-control-wrap', { 'is-error' : errors.name }]">
                        <input type="text" class="form-control" v-model="hotel.names.EN"
                               style="max-width: 42rem"
                               @focus="errors.name = false;isEditFlag = true">

                          <div class="item-checkbox">
                            <div class="form-control-group make-story__checkbox">
                              <label class="form-control-checkbox" style="margin-right: 0">
                                <input
                                    type="checkbox"
                                    v-model="preferredPartner"
                                />
                                <span class="form-control-checkbox__box">
                                  <svg width="1em" height="1em" class="icon icon-check">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                  </svg>
                                </span>
                                <span class="form-control-checkbox__name">Preferred Partner</span>
                              </label>
                              <div v-if="preferredPartner">
                                <ClassicSelect :selected-item="preferredSelectedItem" :items="preferredPartnerSelectData" custom-width="14rem" @select-item="(v) => hotel.preferredPartnerLevel = v.id"/>
                              </div>
                            </div>
                          </div>

                      </div>
                    </div>
                    <div class="form-control-group form-control-group_htl"><span
                        class="form-control-label">Hotel Name (RU)</span>
                      <div :class="['form-control-wrap', { 'is-error' : errors.name }]">
                        <input type="text" class="form-control" v-model="hotel.names.RU"
                               @focus="errors.name = false;isEditFlag = true">
                      </div>
                    </div>

                    <div class="line-cols">
                      <div class="form-control-group"><span
                          class="form-control-label">Hotel Chain</span>
                        <div :class="['select-wrapper', {'is-active' : selects.chain}]"
                             @click="openSelect('chain')">
                          <div class="select-trigger"><span
                              class="select-trigger__name">{{
                              hotel.chain ? hotel.chain.title : ''
                            }}</span><span
                              class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                          <div class="select-body">
                            <div class="select-inner">
                              <div v-for="(item, index) in data.chains" :key="index"
                                   :class="['select-option', { 'is-selected': hotel.chain && item.id === hotel.chain.id }]"
                                   @click="hotel.chain = item;isEditFlag = true"><span
                                  class="select-option__name">{{ item.title }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class="['form-control-group', { 'is-error' : errors.type }]"><span
                          class="form-control-label">Hotel Type</span>
                        <div
                            :class="['select-wrapper', {'is-active' : selects.type}, { 'is-error' : errors.type }]"
                            @click="openSelect('type');errors.type = false">
                          <div class="select-trigger">
                                                      <span class="select-trigger__name">
                                                        <span
                                                            v-if="data.types.find(item => item.active && item.type === 'ECO_LODGES')">
                                                                  <svg width="21" height="15" class="icon-eco-title">
                                                                    <use
                                                                        xlink:href="/images/useful/sprites/sprite.svg#eco-lodge"></use>
                                                                  </svg>
                                                                </span>
                                                        {{
                                                          data.types.find(item => item.active) ? data.types.find(item => item.active).title : ''

                                                        }}
                                                      </span>
                            <span
                                class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                          <div class="select-body">
                            <div class="select-inner">
                              <div v-for="(item, index) in data.types" :key="index"
                                   :class="['select-option', { 'is-selected': item.active }]"
                                   @click="data.types = data.types.map(type => ({...type, active: type.type === item.type}));isEditFlag = true">
                                                                <span v-if="item.type === 'ECO_LODGES'">
                                                                  <svg width="21" height="15" class="icon-eco">
                                                                    <use
                                                                        xlink:href="/images/useful/sprites/sprite.svg#eco-lodge"></use>
                                                                  </svg>
                                                                </span>
                                <span class="select-option__name">{{
                                    item.title
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <label class="form-control-checkbox check-show">
                        <input type="checkbox" v-model="hotel.camp"><span class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                        </svg></span><span class="form-control-checkbox__name"> Mobile Camp</span>
                      </label> -->
                    </div>

                    <div class="form-control-group_htl hotel-language">
                      <div class="form-control-label">Description</div>
                      <div class="languages-group">
                        <label
                            class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                          <input type="radio" name="lanuage" value="EN" v-model="description"
                                 @click="isEditFlag = true">
                          <div class="np-detail-collapse__lang__icon">
                            <svg width="1em" height="1em" class="icon icon-gb ">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                            </svg>
                          </div>
                          <span class="np-detail-collapse__lang__text">English</span>
                        </label>
                        <label
                            class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                          <input type="radio" name="lanuage" value="RU" v-model="description"
                                 @click="isEditFlag = true">
                          <div class="np-detail-collapse__lang__icon">
                            <svg width="1em" height="1em" class="icon icon-rus ">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                            </svg>
                          </div>
                          <span class="np-detail-collapse__lang__text">Russian</span>
                        </label>
                      </div>
                    </div>
                    <div class="form-control-group form-control-group_htl form-control-group_htl-2">
                      <div class="form-control-wrap">
                        <div class="js-ckeditor">
                          <editor :editor="editor"
                                  v-model="hotel.description[description].description"
                                  :config="editorConfig1" @click="isEditFlag = true"></editor>
                        </div>
                      </div>
                    </div>
                    <div class="line-cols line-cols_2 line-cols_geo">
                      <div class="form-control-group"><span
                          class="form-control-label">Country</span>
                        <div
                            :class="['select-wrapper', {'is-active' : selects.country}, { 'is-error' : errors.country }]"
                            @click="openSelect('country');errors.country = false">
                          <div class="select-trigger"><span
                              class="select-trigger__name">{{
                              data.countries.find(item => item.id === hotel.country) ? data.countries.find(item => item.id === hotel.country).name : ''
                            }}</span><span
                              class="select-trigger__icon">
									<svg width="1em" height="1em" class="icon icon-chevron ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
									</svg></span></div>
                          <div class="select-body">
                            <div class="select-inner">
                              <div v-for="item in data.countries" :key="item.id"
                                   :class="['select-option', { 'is-selected' : hotel.country === item.id }]"
                                   @click="selectCountry(item.id)"><span
                                  class="select-option__name">{{ item.name }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          :class="['form-control-group', { 'disabled' : !hotel.country || !filteredTerritories.length }]">
                        <span
                          class="form-control-label">Territory</span>
                        <div
                            :class="['select-wrapper', {'is-active' : selects.territory}, { 'is-error' : errors.territory }]"
                            @click="openSelect('territory');errors.territory = false">
                          <div class="select-trigger"><span
                              class="select-trigger__name">{{
                              filteredTerritories.find(item => item.id === hotel.territory) ? filteredTerritories.find(item => item.id === hotel.territory).names.EN : ''
                            }}</span><span
                              class="select-trigger__icon">
								<svg width="1em" height="1em" class="icon icon-chevron ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
								</svg></span></div>
                          <div class="select-body">
                            <div class="select-inner">
                              <div v-for="item in filteredTerritories" :key="item.id"
                                   :class="['select-option', { 'is-selected' : hotel.territory === item.id }]"
                                   @click="selectTerritory(item.id)"><span
                                  class="select-option__name">{{ item.names.EN }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          :class="['form-control-group', { 'disabled' : !hasSelectedTerritory || !data.locations.length }]">
                        <span class="form-control-label">Location</span>
                        <div
                            :class="['select-wrapper', {'is-active' : selects.location}, { 'is-error' : errors.location }]"
                            @click="openSelect('location');errors.location = false">
                          <div class="select-trigger"><span
                              class="select-trigger__name">{{
                              hasSelectedTerritory && data.locations.find(item => item.id === hotel.location) ? data.locations.find(item => item.id === hotel.location).names.EN : ''
                            }}</span><span
                              class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                          <div class="select-body">
                            <div class="select-inner">
                              <div v-for="item in data.locations" :key="item.id"
                                   :class="['select-option', { 'is-selected' : item.id === hotel.location }]"
                                   @click="selectLocation(item.id)"><span
                                  class="select-option__name">{{ item.names.EN }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          :class="['form-control-group', { 'disabled' : !hasSelectedLocation || !data.areas.length }]">
                        <span class="form-control-label">Area</span>
                        <div
                            :class="['select-wrapper', {'is-active' : selects.area}, { 'is-error' : errors.area }]"
                            @click="openSelect('area');errors.area = false">
                          <div class="select-trigger"><span
                              class="select-trigger__name">{{
                              hasSelectedLocation && data.areas.find(item => item.id === hotel.area) ? data.areas.find(item => item.id === hotel.area).names.EN : ''
                            }}</span><span
                              class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                          <div class="select-body">
                            <div class="select-inner">
                              <div v-for="item in data.areas" :key="item.id"
                                   :class="['select-option', { 'is-selected' : item.id === hotel.area }]"
                                   @click="selectArea(item.id)"><span
                                  class="select-option__name">{{ item.names.EN }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="hotels__coordinates">
                      <div class="form-control-group form-control-group_htl"><span
                          class="form-control-label">Latitude</span>
                        <div :class="['form-control-wrap']">
                          <input type="text" class="form-control" v-model="hotel.latitude">
                        </div>
                      </div>
                      <div class="form-control-group form-control-group_htl"><span
                          class="form-control-label">Longitude</span>
                        <div :class="['form-control-wrap']">
                          <input type="text" class="form-control" v-model="hotel.longitude">
                        </div>
                      </div>
                    </div>
                    <div class="line-cols line-7">
                      <div class="form-control-group"><span class="form-control-label">
                              <svg width="1em" height="1em" class="icon icon-airplane " :style="{marginRight: '5px'}"><use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use></svg>Closest Airport / Airstrip</span>
                        <div
                            :class="['select-wrapper', {'is-active' : selects.airport}, { 'is-error' : errors.airstrip }]"
                            @click="openSelect('airport');errors.airstrip = false">
                          <div class="select-trigger"><span
                              class="select-trigger__name">{{
                              hotel.airstrip ? hotel.airstrip.names.EN : ''
                            }}</span><span
                              class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                          <div class="select-body">
                            <div class="select-inner">
                              <div v-for="(item, index) in data.airstrips" :key="index"
                                   :class="['select-option', { 'is-selected' : hotel.airstrip && item.id === hotel.airstrip.id }]"
                                   @click="hotel.airstrip = item;isEditFlag = true"><span
                                  class="select-option__name">{{ item.names.EN }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          class="form-control-group form-control-group--time form-control-group--time_half is-active">
                        <span class="form-control-label">Transfer Time (min)</span>
                        <div class="form-control-wrap">
                          <input type="number" v-model="hotel.transferTime"
                                 class="form-control"
                                 @focus="isEditFlag = true">
                        </div>
                      </div>
                    </div>
                    <div class="form-control-group line-cols_2_amenities">
                      <span class="hotel-subtitle">AMENITIES</span>
                      <div class="form-control-wrap">
                        <div class="group-checkboxes">
                          <label v-for="(item, index) in data.tags" :key="index"
                                 :class="['checkbox-square', { 'is-error' : errors.amenities }]">
                            <input type="checkbox" v-model="item.active"
                                   @change="errors.amenities = false;isEditFlag = true">
                            <span :data-redlabel="item.bgColor === 'red'" :class="['checkbox-square__label', {'is-error' : false, 'red': item.active && item.bgColor === 'red'}]">
									<svg width="1em" height="1em" :class="'icon icon-' + item.icon">
                    <use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + item.icon"></use>
                  </svg>
                              {{
                                item.name
                              }}
								</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="hr"></div>
                    <div class="hotel-switch__wrapper">
                      <div class="hotel-switch__title">1 Bed in Twin Available</div>
                      <div class="hotel-switch__container">
                        <span :class="{'hotel-switch--selected-side': oneBedInTwinAvailable === false}">No</span>
                        <ClassicSwitch v-model="oneBedInTwinAvailable"/>
                        <span :class="{'hotel-switch--selected-side': oneBedInTwinAvailable === true}">Yes</span>
                      </div>
                    </div>
                    <div class="hr"></div>
                    <div class="form-control-group form-control-group_photo">
                      <div class="hotel-subtitle">Photo Gallery</div>
                      <div class="photo-hotel-add">
                        <div
                            v-for="(item, index) in hotel.photos"
                            :key="index"
                            class="form-control-photo-group form-control-photo-group--squared form-control-photo-group--visible-btn photo-hotel-add__item"
                        >
                          <div class="form-control-photo"><span
                              class="form-control-photo__box h-object-fit">
									<img :src="`${API}/documents/share/images/${item}?size=LARGE`" alt="">
								</span>
                            <button type="button" class="btn btn--remove"
                                    @click="hotel.photos = hotel.photos.filter((_, i) => i === index ? false : true)">
                              <svg width="1em" height="1em" class="icon icon-close ">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                              </svg>
                            </button>
                          </div>
                        </div>


                        <div @click="$emit('changeImage', 'hotel')"
                             class="form-control-photo-group form-control-photo-group--squared form-control-photo-group--visible-btn photo-hotel-add__item">
                          <input type="file" id="photo_load" class="input-hidden">
                          <label for="photo_load1" class="form-control-photo"><span
                              class="form-control-photo__box h-object-fit"></span>
                            <button type="button" class="btn btn--plus">
                              <svg width="1em" height="1em" class="icon icon-plus">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus"></use>
                              </svg>
                            </button>
                          </label>
                        </div>
                      </div>
                      <div class="hotel-notes">Minimum image size: 900 x 606p
                        <div>Max 5 MB</div>
                      </div>
                    </div>
                    <div class="form-control-group form-control-group_htl form-control-group_htl_3"><span
                        class="form-control-label">Meal Plan Type</span>
                      <div class="form-control-wrap">
                        <div class="group-checkboxes">
                          <label v-for="(item, index) in data.meals" :key="index"
                                 :class="['checkbox-round', { 'is-error' : errors.meal }]">
                            <input type="checkbox" v-model="item.active"
                                   @change="errors.meal = false">
                            <span class="checkbox-round__label">{{ item.name }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="line-cols">
                      <div
                          class="form-control-group form-control-group--time form-control-group--time_half is-active">
                        <span class="form-control-label">Check In</span>
                        <div :class="['form-control-wrap', { 'is-error' : errors.checkIn }]">
                          <the-mask type="text" v-model="hotel.check.in"
                                    @click="errors.checkIn = false;isEditFlag = true"
                                    @input="errors.checkIn = false;hotel.check.in = +hotel.check.in.slice(0, 2) > 23 ? 23 : hotel.check.in;hotel.check.in.length === 4 ? hotel.check.in = +hotel.check.in.slice(2, 5) > 59 ? hotel.check.in.slice(0, 2) + '59' : hotel.check.in : false "
                                    class="form-control form-control-time" :mask="'##:##'"
                                    placeholder="--:--"/>
                        </div>
                      </div>
                      <div
                          class="form-control-group form-control-group--time form-control-group--time_half is-active">
                        <span class="form-control-label">Check Out</span>
                        <div :class="['form-control-wrap', { 'is-error' : errors.checkOut }]">
                          <the-mask type="text" v-model="hotel.check.out"
                                    @click="errors.checkOut = false;isEditFlag = true"
                                    @input="errors.checkOut = false;hotel.check.out = +hotel.check.out.slice(0, 2) > 23 ? 23 : hotel.check.out;hotel.check.out.length === 4 ? hotel.check.out = +hotel.check.out.slice(2, 5) > 59 ? hotel.check.out.slice(0, 2) + '59' : hotel.check.out : false "
                                    class="form-control form-control-time" :mask="'##:##'"
                                    placeholder="--:--"/>
                        </div>
                      </div>
                    </div>
                    <div class="hr"></div>
                    <div class="line-4">
                      <div class="hotel-subtitle">Age settings</div>
                      <div class="ui-section-age">
                        <div class="ui-section-age__col">
                          <div class="age-box">
                            <div class="age-box__icon">
                              <div class="age-box__icon__box">
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </div>
                              <span class="age-box__icon__name">Child</span>
                            </div>
                            <div class="age-box__inner">
                              <div class="age-box__inner__descr"><span>To</span></div>
                              <div class="age-box__inner__input">
                                <input id="js-age-box__inner__input-child"
                                       type="number"
                                       placeholder="0"
                                       min="0"
                                       @blur="calcAge"
                                       v-model="hotel.age.child" class="form-control"
                                       @focus="isEditFlag = true"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ui-section-age__col">
                          <div class="age-box">
                            <div class="age-box__icon">
                              <div class="age-box__icon__box">
                                <svg width="1em" height="1em"
                                     class="icon icon-teenager ">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </div>
                              <span class="age-box__icon__name">Teenager</span>
                            </div>
                            <div class="age-box__inner">
                              <div class="age-box__inner__descr"><span>From</span></div>
                              <div class="age-box__inner__input">
                                <input id="js-age-box__inner__input-teenMin"
                                       type="number"
                                       placeholder="0"
                                       min="0"
                                       @blur="calcAge"
                                       v-model="hotel.age.teenMin"
                                       @focus="isEditFlag = true" class="form-control"/>
                              </div>
                            </div>
                            <div class="age-box__inner">
                              <div class="age-box__inner__descr"><span>To</span></div>
                              <div class="age-box__inner__input">
                                <input id="js-age-box__inner__input-teenMax" type="number"
                                       placeholder="0"
                                       min="0"
                                       @blur="calcAge"
                                       v-model="hotel.age.teenMax"
                                       @focus="isEditFlag = true" class="form-control"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ui-section-age__col">
                          <div class="age-box">
                            <div class="age-box__icon">
                              <div class="age-box__icon__box">
                                <svg width="1em" height="1em" class="icon icon-adult ">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </div>
                              <span class="age-box__icon__name">Adult</span>
                            </div>
                            <div class="age-box__inner">
                              <div class="age-box__inner__descr"><span>From</span></div>
                              <div class="age-box__inner__input">
                                <input id="js-age-box__inner__input-adult" type="number"
                                       placeholder="0"
                                       min="0"
                                       @blur="calcAge"
                                       v-model="hotel.age.adult"
                                       @focus="isEditFlag = true" class="form-control"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="hr"></div>

                    <div class="hotel-location">
                      <div class="hotel-location__wrapper">
                        <div class="hotel-location__switch-wrapper">
                          <div class="hotel-location__title">Hotel located inside the National Park?</div>
                          <div class="hotel-location__switch-container">
                            <span :class="{'hotel-location--selected-side': locatedInPark === false}">No</span>
                            <ClassicSwitch v-model="locatedInPark"/>
                            <span :class="{'hotel-location--selected-side': locatedInPark === true}">Yes</span>
                          </div>
                        </div>
                        <div class="hotel-location__switch-wrapper" :class="{'hotel-location__alert': locatedInPark === true && concessionFeesIncl === false}">
                          <div class="hotel-location__sub-label">Did you add Concession Fees into the rates?</div>
                          <div class="hotel-location__switch-container">
                            <span :class="{'hotel-location--selected-side': concessionFeesIncl === false}">No</span>
                            <ClassicSwitch v-model="concessionFeesIncl"/>
                            <span :class="{'hotel-location--selected-side': concessionFeesIncl === true}">Yes</span>
                          </div>
                          <span class="hotel-location__alert-text"
                                v-if="locatedInPark === true && concessionFeesIncl === false">
                            <svg
                                class="icon hotel-location__alert-icon important-icon">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                            </svg>
                            <span>Concession fees are not included</span>
                          </span>

                        </div>
                        <div v-if="locatedInPark">
                          <div class="hotel-location__sub-label">Select National Park</div>
                          <div class="hotel-location__select-wrapper">
                            <ClassicSelect :selected-item="selectedPark || null" :items="parks" @select-item="(v) => selectedPark = v"/>
                          </div>
                        </div>

                      </div>
                      <div class="hr"></div>
                      <div class="hotel-location__wrapper">
                        <div class="hotel-location__switch-wrapper">
                          <div class="hotel-location__title">Hotel located in Wildlife Managment Area?</div>
                          <div class="hotel-location__switch-container">
                            <span :class="{'hotel-location--selected-side': locatedInWMA === false}">No</span>
                            <ClassicSwitch v-model="locatedInWMA" @click="toggleLocationSwitch('locatedInWMA')"/>
                            <span :class="{'hotel-location--selected-side': locatedInWMA === true}">Yes</span>
                          </div>
                        </div>
                        <div v-if="locatedInWMA">
                          <div class="hotel-location__sub-label">Select WMA Zone</div>
                          <div class="hotel-location__select-wrapper">
                            <ClassicSelect :selected-item="wmaZone || null" :items="wmaZoneList" @select-item="(v) => wmaZone = v"/>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="hr"></div>
                    <div class="hotel-cancellation__wrapper">
                      <div class="hotel-cancellation__title">CANCELLATION POLICY</div>
                      <div class="hotel-cancellation__fields">
                        <div class="hotel-cancellation__labels">
                          <div class="hotel-cancellation__label">Cancellation Period</div>
                          <div class="hotel-cancellation__label">Charge</div>
                          <div class="hotel-cancellation__label">Additional Note</div>
                        </div>
                        <div class="hotel-cancellation__inputs" v-for="(policy, index) in cancellationPolicies" :key="index">
                          <BasicInput type="number" v-model="policy.days"/>
                          <div
                              :class="[
                            'additional-block__input',
                            'additional-block__input--decor',
                        ]">
                            <BasicInput type="number" :valueModifier="(val) => val > 100 ? val = 100 : val" v-model="policy.charge"/>
                            <span>%</span>
                          </div>
                          <BasicInput type="text" v-model="policy.notes"/>
                          <button
                              @click="onCancellationPolicyRemove(index)"
                              type="button"
                              class="additional-block__delete">
                            <img src="/images/disc-delete.svg" alt="" />
                          </button>
                        </div>

                        <button
                            @click="onCancellationPolicyAdd"
                            class="additional-block__add hotel-cancellation__add"
                            type="button">
                          Add
                        </button>

                      </div>
                    </div>
                    <div class="hr"></div>
                    <div class="line-9">
                          <span class="input-icon"><svg width="1em" height="1em" class="icon icon-site ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-site"></use>
                                  </svg></span>
                      <span class="input-label">Hotel Website:</span>
                      <input type="text" v-model="hotel.site"
                             class="form-control form-control_site"
                             @click="isEditFlag = true">
                    </div>
                    <div class="line-9">
                          <span class="input-icon"><svg width="1em" height="1em" class="icon icon-site ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-youtube"></use>
                                  </svg></span>
                      <span class="input-label">Video link:</span>
                      <input type="text" v-model="hotel.videoReviewUrl"
                             class="form-control form-control_site"
                             @click="isEditFlag = true">
                    </div>
                    <div class="line-cols line-cols_3 line-10">
                      <div class="form-control-group"><span class="form-control-label">Reservation Email (Main)</span>
                        <input type="email" class="form-control" v-model="hotel.emails.res1"
                               @click="isEditFlag = true">
                      </div>
                      <div class="form-control-group"><span class="form-control-label">Reservation Email (Alt 1)</span>
                        <input type="email" class="form-control" v-model="hotel.emails.res2"
                               @click="isEditFlag = true">
                      </div>
                      <div class="form-control-group"><span class="form-control-label">Reservation Email (Alt 2)</span>
                        <input type="email" class="form-control" v-model="hotel.emails.res3"
                               @click="isEditFlag = true">
                      </div>
                    </div>
                    <div class="line-9 line-9-1">
                          <span class="input-icon"><svg width="1em" height="1em" class="icon icon-booking ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-booking"></use>
                                  </svg></span>
                      <span class="input-label">Booking.com:</span>
                      <input type="text" v-model="hotel.booking "
                             class="form-control form-control_site"
                             @click="isEditFlag = true" value="Aishi Machame Hotel">
                    </div>
                    <div class="line-9 line-9-2">
                          <span class="input-icon"><svg width="1em" height="1em" class="icon icon-tripadvisor ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-tripadvisor"></use>
                                  </svg></span>
                      <span class="input-label">TripAdvisor.com:</span>
                      <input type="text" v-model="hotel.trip "
                             class="form-control form-control_site"
                             @click="isEditFlag = true" value="Aishi Machame Hotel">
                    </div>
                    <div class="hr"></div>
                    <div class="form-control-group form-control-group_notes">
                      <span class="hotel-subtitle hotel-subtitle_note">NOTES</span>
                      <div class="form-control-wrap">
                        <editor :editor="editor" v-model="hotel.notes" :config="editorConfig2"
                                @click="isEditFlag = true"></editor>
                      </div>
                    </div>
                    <div class="edit-rooms__btn-edit">
                      <button type="button" class="btn btn--green" :disabled="isCalcAge"
                              @click="$route.params.id !== 'add' ? updatePopup = true : createHotelAdvancedHandler()">
                        <span>{{ $route.params.id !== 'add' ? 'Update' : 'Save' }}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="modal-wrapper" v-if="updatePopup">
              <div class="modal-backdrop"></div>
              <div class="modal-inner">
                <div class="edit-popup edit-popup--history">
                  <div class="edit-popup__header">
                    <div class="edit-popup__title">
                      Update History
                    </div>
                    <div class="edit-popup__close" @click="updatePopup = false">
                      <svg width="1em" height="1em" class="icon icon-close ">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </div>
                  </div>
                  <form action="javascript:void(0)" class="edit-popup__inner">
                    <div class="form-control-group"><span
                        class="form-control-label">Hi {{ user ? user.data.firstName : '' }}, <span> what have you updated?</span> </span>
                      <div class="form-control-wrap">
                        <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                      </div>
                      <div class="edit-popup__error-text">
                        <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                      </div>
                    </div>
                    <div class="options-additional__btns">
                      <button type="button" class="btn btn--silver" @click="updatePopup = false">
                        <span>Cancel</span>
                      </button>
                      <button type="submit" class="btn btn--green edit-popup__submit"
                              :disabled="descriptionUpdate.length < 6"
                              @click="updateHotelAdvancedHandler()">
                        <span>Update</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

import {
  API,
  getTerritoriesAll,
  getLocationsTerritoriesAll,
  getAreasLocaitonAll,
  getHotelsChains,
  createHotelAdvanced,
  updateHotelAdvanced,
  getHotelAdvanced,
  getAirstripsAll, getParks, getCountries
} from '@/utilites/api'

import Lightpick from 'lightpick'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'
import ClassicSelect from "@/components/UI/ClassicSelect/ClassicSelect.vue";
import ClassicSwitch from "@/components/UI/Switch/ClassicSwitch.vue";
import {TheMask} from 'vue-the-mask'
import BasicInput from "@/components/UI/Inputs/BasicInput.vue";
import Input from "@/components/UI/Inputs/BasicInput.vue";
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
  data() {
    return {
      cancellationPolicies: [],
      isCalcAge: false,
      isLoad: false,
      editor: ClassicEditor,
      isEditFlag: false,
      descriptionUpdate: '',
      isEdit: false,
      API,
      editorConfig1: {
        placeholder: 'Write description'
      },
      editorConfig2: {
        placeholder: 'Write notes'
      },
      preferredPartnerSelectData: [
        {id: 'GOLD', name: 'Gold', icon: 'preferred-icon-gold'},
        {id: 'SILVER', name: 'Silver', icon: 'preferred-icon-silver'},
        {id: 'BRONZE', name: 'Bronze', icon: 'preferred-icon-bronze'},
      ],
      preferredPartner: false,
      history: false,
      hotel: {
        names: {EN: '', RU: ''},
        active: false,
        bestPrice: false,
        lowPriority: false,
        chain: null,
        sortPriority: null,
        type: null,
        rating: 0,
        camp: false,
        preferredPartnerLevel: 'GOLD',
        description: {
          'EN': {
            'description': ''
          },
          'RU': {
            'description': ''
          },
        },
        meal: [],
        age: {
          child: '',
          teenMin: '',
          teenMax: '',
          adult: ''
        },
        site: '',
        videoReviewUrl: '',
        emails: {
          res1: '',
          res2: '',
          res3: '',
        },
        booking: '',
        trip: '',
        notes: '',
        check: {
          in: '',
          out: ''
        },
        country: null,
        territory: null,
        location: null,
        latitude: null,
        longitude: null,
        area: null,
        airstrip: null,
        amenities: [],
        transferTime: '',
        photos: [],
        parkId: null,
      },
      description: 'EN',
      parks: [],
      selectedPark: null,
      wmaZoneList: [
        {id: 'Ikona', name: 'Ikona'},
        {id: 'Makao', name: 'Makao'},
        {id: 'Enduimet', name: 'Enduimet'},
        {id: 'Burunge', name: 'Burunge'},
        {id: 'Makame', name: 'Makame'},
        {id: 'Uyumbu', name: 'Uyumbu'},
        {id: 'Ipole', name: 'Ipole'},
        {id: 'Wami mbiki', name: 'Wami mbiki'},
        {id: 'Ukutu', name: 'Ukutu'},
        {id: 'Idodi Pawaga', name: 'Idodi Pawaga'},
        {id: 'Ngarambe Tapika', name: 'Ngarambe Tapika'},
        {id: 'Liwale', name: 'Liwale'},
        {id: 'Tunduru', name: 'Tunduru'},
        {id: 'Mbaragandu', name: 'Mbaragandu'},
        {id: 'Sangaiwe', name: 'Sangaiwe'},
        {id: 'Randilen', name: 'Randilen'},
        {id: 'Engaresero', name: 'Engaresero'},
        {id: 'Losiruwa', name: 'Losiruwa'},
      ],
      wmaZone: null,
      locatedInPark: false,
      concessionFeesIncl: false,
      oneBedInTwinAvailable: false,
      locatedInWMA: false,
      selects: {
        chain: false,
        type: false,
        country: false,
        location: false,
        area: false,
        mobileArea: false,
        mobileClosest: false,
        airport: false,
        star: false
      },
      updatePopup: false,
      errors: {
        name: false,
        description: false,
        type: false,
        meal: false,
        country: false,
        territory: false,
        location: false,
        area: false,
        checkIn: false,
        checkOut: false,
        amenities: false
      },
      data: {
        countries: [],
        territories: [],
        locations: [],
        areas: [],
        chains: [],
        starts: [{star: '0'}, {star: '0.5'}, {star: '1'}, {star: '1.5'}, {star: '2'}, {star: '2.5'}, {star: '3'}, {star: '3.5'}, {star: '4'}, {star: '4.5'}, {star: '5'}],
        airstrips: [],
        types: [
          {
            type: 'CLASSIC',
            title: 'Classic',
            active: false
          },
          {
            type: 'LUXURY',
            title: 'Luxury',
            active: false
          },
          {
            type: 'VIP',
            title: 'VIP',
            active: false
          },
          {
            type: 'ECO_LODGES',
            title: 'Eco Lodge',
            active: false
          }
        ],
        meals: [
          {
            name: 'BB',
            active: false
          },
          {
            name: 'HB',
            active: false
          },
          {
            name: 'FB',
            active: false
          },
          {
            name: 'AI',
            active: false
          },
          {
            name: 'GP',
            active: false
          }
        ],
        tags: [
          {
            name: 'WiFi',
            data: 'WIFI',
            active: false,
            icon: 'wifi',
            bgColor: 'green'
          },
          {
            name: 'Public Area Wi-Fi only',
            data: 'PUBLIC_AREA_WIFI',
            active: false,
            icon: 'public_area_wifi',
            bgColor: 'red'
          },
          {
            name: 'Swimming pool',
            data: 'SWIMMING_POOL',
            active: false,
            icon: 'pool',
            bgColor: 'green'
          },
          {
            name: 'Laundry service',
            data: 'LAUNDRY',
            active: false,
            icon: 'laundry',
            bgColor: 'green'
          },
          {
            name: 'Gym',
            data: 'GYM',
            active: false,
            icon: 'gym',
            bgColor: 'green'
          },
          {
            name: 'Air Conditioner',
            data: 'CONDITIONER',
            active: false,
            icon: 'conditioner',
            bgColor: 'green'
          },
          {
            name: 'NO Air Conditioner',
            data: 'NO_AIR_CONDITIONER',
            active: false,
            icon: 'no_air_conditioner',
            bgColor: 'red'
          },
          {
            name: 'Fan in the Room',
            data: 'FAN_IN_ROOM',
            active: false,
            icon: 'fan_in_room',
            bgColor: 'green'
          },
          {
            name: 'Wildlife area',
            data: 'WILDLIFE_AREA',
            active: false,
            icon: 'wildlife',
            bgColor: 'green'
          },
          {
            name: 'Spa',
            data: 'SPA',
            active: false,
            icon: 'spa',
            bgColor: 'green'
          },
          {
            name: 'Restaurant',
            data: 'RESTAURANT',
            active: false,
            icon: 'restaurant',
            bgColor: 'green'
          },
          {
            name: 'Limited Electricity',
            data: 'LIMITED_ELECTRICITY',
            active: false,
            icon: 'limited_electricity',
            bgColor: 'red'
          },
          {
            name: 'Public Area Chargers only',
            data: 'PUBLIC_AREA_CHARGES',
            active: false,
            icon: 'public_area_charges',
            bgColor: 'red'
          },
          {
            name: 'Hair Dryer Available',
            data: 'HAIR_DRYER_AVAILABLE',
            active: false,
            icon: 'hair_dryer_available',
            bgColor: 'green'
          },
          {
            name: 'No Hair Dryer',
            data: 'NO_HAIR_DRYER',
            active: false,
            icon: 'no_hair_dryer',
            bgColor: 'red'
          },
          {
            name: 'Mosquito Nets',
            data: 'MOSQUITO_NETS',
            active: false,
            icon: 'mosquito_nets',
            bgColor: 'green'
          },
          {
            name: 'Bucket Shower',
            data: 'BUCKET_SHOWER',
            active: false,
            icon: 'bucket_shower',
            bgColor: 'red'
          }
        ],
      },
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEditFlag) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  props: ['uploadedFile', 'user'],
  components: {
    HotelsSideMenu,
    Input, BasicInput, editor: CKEditor.component, Lightpick, TheMask, ClassicSwitch, ClassicSelect },
  beforeCreate() {
    document.title = 'Hotels'
  },
  computed: {
    filteredTerritories() {
      if (!this.hotel.country) return []

      return this.data.territories.filter(territory =>
          territory.country && territory.country.id === this.hotel.country
      )
    },
    hasSelectedTerritory() {
      return this.filteredTerritories.some(territory => territory.id === this.hotel.territory)
    },
    hasSelectedLocation() {
      return this.hasSelectedTerritory &&
          this.data.locations.some(location => location.id === this.hotel.location)
    },
    preferredSelectedItem() {
      return this.preferredPartnerSelectData.find(i => i.id === this.hotel.preferredPartnerLevel);
    }
  },
  mounted() {
    this.updateData()
    this.updateDatePickers()
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          chain: false,
          type: false,
          country: false,
          location: false,
          area: false,
          mobileArea: false,
          mobileClosest: false,
          airport: false,
        }
      }
    })
  },
  methods: {
    selectCountry(countryId) {
      if (this.hotel.country !== countryId) {
        this.hotel.territory = null
        this.hotel.location = null
        this.hotel.area = null
        this.data.locations = []
        this.data.areas = []
      }

      this.hotel.country = countryId
      this.isEditFlag = true
    },
    selectTerritory(territoryId) {
      if (this.hotel.territory !== territoryId) {
        this.hotel.location = null
        this.hotel.area = null
        this.data.locations = []
        this.data.areas = []
      }

      this.hotel.territory = territoryId
      this.isEditFlag = true
    },
    selectLocation(locationId) {
      if (this.hotel.location !== locationId) {
        this.hotel.area = null
        this.data.areas = []
      }

      this.hotel.location = locationId
      this.isEditFlag = true
    },
    selectArea(areaId) {
      this.hotel.area = areaId
      this.isEditFlag = true
    },
    onCancellationPolicyAdd() {
      this.cancellationPolicies.push({})
    },
    onCancellationPolicyRemove(index) {
      this.cancellationPolicies.splice(index, 1)
    },
    calcAge() {
      const child = document.getElementById('js-age-box__inner__input-child')
      const teenMin = document.getElementById('js-age-box__inner__input-teenMin')
      const teenMax = document.getElementById('js-age-box__inner__input-teenMax')
      const adult = document.getElementById('js-age-box__inner__input-adult')

      const colorSuccess = 'white'
      const colorError = 'rgba(244, 152, 152, 0.2)'

      if (+this.hotel.age.child === 0 && +this.hotel.age.teenMin === 0 && +this.hotel.age.teenMax === 0 && +this.hotel.age.adult === 0) {
        child.style.backgroundColor = colorError
        teenMin.style.backgroundColor = colorError
        teenMax.style.backgroundColor = colorError
        adult.style.backgroundColor = colorError

        this.isCalcAge = true
      }

      if ((+this.hotel.age.child < +this.hotel.age.teenMin) && (+this.hotel.age.teenMin < +this.hotel.age.teenMax) && (+this.hotel.age.teenMax < +this.hotel.age.adult)) {
        this.isCalcAge = false
      }

      if (+this.hotel.age.child < +this.hotel.age.teenMin && +this.hotel.age.child !== 0) {
        child.style.backgroundColor = colorSuccess
      } else {
        child.style.backgroundColor = colorError
        this.isCalcAge = true

      }

      if (+this.hotel.age.teenMin < +this.hotel.age.teenMax && +this.hotel.age.teenMin !== 0) {
        teenMin.style.backgroundColor = colorSuccess
      } else {
        teenMin.style.backgroundColor = colorError
        this.isCalcAge = true

      }

      if (+this.hotel.age.teenMax < +this.hotel.age.adult && +this.hotel.age.teenMax !== 0) {
        teenMax.style.backgroundColor = colorSuccess
      } else {
        teenMax.style.backgroundColor = colorError
        this.isCalcAge = true

      }

      if (+this.hotel.age.teenMax < +this.hotel.age.adult) {
        adult.style.backgroundColor = colorSuccess
      } else {
        adult.style.backgroundColor = colorError
        this.isCalcAge = true

      }
    },
    openSelect(name) {
      this.selects = {
        chain: false,
        type: false,
        country: false,
        location: false,
        area: false,
        mobileArea: false,
        mobileClosest: false,
        airport: false,
        star: false,
        [name]: !this.selects[name]
      }
    },
    updateData() {
      const id = this.$route.params.id
      this.isEdit = id !== 'add'
      Promise.all([getTerritoriesAll(), getHotelsChains(), getAirstripsAll(), getParks(), getCountries()])
          .then(res => {
            this.data.territories = res[0]
            this.data.chains = res[1].sort((a, b) => a.title > b.title ? 1 : -1)

            this.data.airstrips = res[2].map(item => ({
              ...item.airstrip
            })).sort((a, b) => a.names.EN > b.names.EN ? 1 : -1)

            if (this.isEdit) {
              getHotelAdvanced(id)
                  .then(res => {
                    this.hotel = {
                      names: {
                        EN: res.names.EN,
                        RU: res.names.RU || res.names.EN,
                      },
                      active: res.active,
                      bestPrice: res.bestPrice,
                      lowPriority: res.lowPriority,
                      chain: this.data.chains.find(item => item.id === res.chainId),
                      sortPriority: res.sortPriority,
                      rating: res.ratio,
                      camp: res.mobileCamp,
                      preferredPartnerLevel: res.preferredPartnerLevel,
                      description: {
                        'EN': {
                          'description': res.descriptions.EN
                        },
                        'RU': {
                          'description': res.descriptions.RU
                        },
                      },
                      age: {
                        child: res.ageSettings.child.to,
                        teenMin: res.ageSettings.teenager.from,
                        teenMax: res.ageSettings.teenager.to,
                        adult: res.ageSettings.adult.from
                      },
                      site: res.website,
                      videoReviewUrl: res.videoReviewUrl,
                      emails: {
                        res1: res.emailMain,
                        res2: res.emailAlt1,
                        res3: res.emailAlt2,
                      },
                      latitude: res.latitude,
                      longitude: res.longitude,
                      booking: res.booking,
                      trip: res.tripAdvisor,
                      notes: res.notes || '',
                      check: {
                        in: res.checkIn,
                        out: res.checkOut
                      },
                      country: res.countryId,
                      territory: res.territoryId,
                      location: res.locationId,
                      area: res.areaId,
                      airstrip: this.data.airstrips.find(item => item.id === res.airstripId),
                      transferTime: res.transferTimeMin,
                      photos: res.photoIds
                    }
                    this.cancellationPolicies = res.cancellationPolicies;
                    this.locatedInPark = res.locatedInPark;
                    this.locatedInWMA = res.locatedInWMA;
                    this.oneBedInTwinAvailable = res.oneBedInTwinAvailable;
                    this.concessionFeesIncl = res.concessionFeesIncl;
                    this.hotel.parkId = res.parkId;
                    if (res.wmaZone) {
                      this.wmaZone = { id: res.wmaZone, name: res.wmaZone };
                    }
                    this.preferredPartner = res.preferredPartnerLevel ? true : false;
                    this.data.tags = this.data.tags.map(item => ({
                      ...item,
                      active: res.amenities.includes(item.data)
                    }))
                    this.data.meals = this.data.meals.map(item => ({
                      ...item,
                      active: res.mealPlanTypes.includes(item.name)
                    }))
                    this.data.types = this.data.types.map(item => ({
                      ...item,
                      active: res.type === item.type
                    }))
                  })
            }
            this.isLoad = true
            this.isEditFlag = false
            this.parks = this.formatParksData(res[3]);
            this.data.countries = res[4]
          })
    },
    formatParksData(parks) {
      return parks.map((park) => ({ id: park.id, name: park.nameForClient }));
    },
    generateData(update = false) {
      let data = {
        "hotel": {
          names: this.hotel.names,
          "ratio": +this.hotel.rating,
          "active": this.hotel.active,
          "bestPrice": this.hotel.bestPrice,
          "lowPriority": this.hotel.lowPriority,
          "chainId": this.hotel.chain ? this.hotel.chain.id : null,
          sortPriority: this.hotel.sortPriority,
          "type": this.data.types.find(item => item.active).type,
          "descriptions": {
            "EN": this.hotel.description.EN.description,
            "RU": this.hotel.description.RU.description,
          },
          "mealPlanTypes": this.data.meals.filter(item => item.active).map(item => item.name),
          "countryId": this.hotel.country,
          "territoryId": this.hotel.territory,
          "locationId": this.hotel.location,
          "areaId": this.hotel.area,
          "airstripId": this.hotel.airstrip ? this.hotel.airstrip.id : null,
          "transferTimeMin": +this.hotel.transferTime,
          "checkIn": this.hotel.check.in.substr(0, 2) + ':' + this.hotel.check.in.substring(this.hotel.check.in.length - 2),
          "checkOut": this.hotel.check.out.substr(0, 2) + ':' + this.hotel.check.out.substring(this.hotel.check.out.length - 2),
          "ageSettings": {
            "child": {
              "from": 0,
              "to": +this.hotel.age.child
            },
            "teenager": {
              "from": +this.hotel.age.teenMin,
              "to": +this.hotel.age.teenMax
            },
            "adult": {
              "from": +this.hotel.age.adult,
              "to": 100
            }
          },
          "locatedInPark": this.locatedInPark,
          "latitude": this.hotel.latitude,
          "longitude": this.hotel.longitude,
          "parkId": this.locatedInPark ? this.selectedPark.id : null,
          "concessionFeesIncl": this.concessionFeesIncl,
          "locatedInWMA": this.locatedInWMA,
          "oneBedInTwinAvailable": this.oneBedInTwinAvailable,
          "wmaZone": this.locatedInWMA ? this.wmaZone.id : null,
          "mobileCamp": this.hotel.camp,
          "amenities": this.data.tags.filter(item => item.active).map(item => item.data),
          "photoIds": this.hotel.photos,
          "preferredPartnerLevel": this.preferredPartner ? this.hotel.preferredPartnerLevel : null,
          "website": this.hotel.site,
          "videoReviewUrl": this.hotel.videoReviewUrl,
          "booking": this.hotel.booking,
          "emailMain": this.hotel.emails.res1,
          "emailAlt1": this.hotel.emails.res2,
          "emailAlt2": this.hotel.emails.res3,
          "tripAdvisor": this.hotel.trip,
          "notes": this.hotel.notes,
          "cancellationPolicies": this.cancellationPolicies
        },
      }
      if (update) {
        data.history = {
          "hotelId": this.$route.params.id,
          "userId": this.user.id,
          "description": this.descriptionUpdate
        }
        data.hotel.id = +this.$route.params.id
      } else {
        data.history = {
          "userId": this.user.id,
          "description": 'Hotel created'
        }
      }
      return data
    },
    checkErrors() {
      this.errors = {
        name: !this.hotel.names.EN.length &&
            !this.hotel.names.RU.length,
        airstrip: !this.hotel.airstrip,
        type: !this.data.types.find(item => item.active),
        meal: !this.data.meals.find(item => item.active),
        country: !this.hotel.country,
        territory: !this.hotel.territory,
        location: !this.hotel.location,
        area: !this.hotel.area,
        checkIn: this.hotel.check.in.length < 4,
        checkOut: this.hotel.check.out.length < 4,
        amenities: !this.data.tags.find(item => item.active)
      }
      let error = false
      for (const key in this.errors) {
        if (this.errors[key]) {
          error = true
        }
      }
      if (error) {
        window.scrollTo({
          top: 0
        })
        return true
      }
      return false
    },
    createHotelAdvancedHandler() {
      if (!this.checkErrors()) {
        createHotelAdvanced(this.generateData())
            .then(res => {
              this.$emit('confirmed')
              this.$router.push('/hotels/' + res.id + '/hotel')
              this.$emit('forceRerender')
              this.isEditFlag = false
              window.scrollTo({
                top: 0,
                // behavior: 'smooth'
              })
            })
            .catch(() => this.$emit('errored', {text: '', time: 3000}))
      }
    },
    updateHotelAdvancedHandler() {
      if (!this.checkErrors()) {
        updateHotelAdvanced(this.generateData(true))
            .then(res => {
              this.$emit('confirmed')
              this.updatePopup = false
              this.isEditFlag = false
              this.hotel.descriptionUpdate = ''
            })
            .catch(() => this.$emit('errored', {text: '', time: 3000}))
      }
    },
    toggleLocationSwitch(switchKey) {
      switch (switchKey) {
        case 'locatedInPark':
          if (this.locatedInPark === true) {
            this.locatedInWMA = false;
          }
          break;
        case 'locatedInWMA':
          if (this.locatedInWMA === true) {
            this.locatedInPark = false;
          }
          break;
      }
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach(elem => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach(item => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD MMM YYYY',
            onClose: function () {
              item.blur()
            },
            onSelect: function () {
              item.focus()
              item.blur()
            }
          });
          item.addEventListener('blur', () => {
            datePicker.hide()
          })
        });
      }, 1000)
    },
    waitSaveTiming() {
      const saveFun = () => {
        this.$route.params.id !== 'add' ? this.updatePopup = true : this.createHotelAdvancedHandler()
      }
      const waitFun = () => {
        this.waitSaveTiming();
      }
      setTimeout(() => {
        this.$emit('waitSaveHandler', [saveFun, waitFun]);
      }, 10 * 60 * 1000)
    },
  },
  watch: {
    isEditFlag(val) {
      if (val) this.waitSaveTiming();
    },
    locatedInPark() {
      if (this.locatedInPark === true) {
        this.locatedInWMA = false;
      }
    },
    locatedInWMA() {
      if (this.locatedInWMA === true) {
        this.locatedInPark = false
      }
    },
    uploadedFile() {
      if (this.uploadedFile) {
        this.hotel.photos = this.hotel.photos.concat(this.uploadedFile)
      }
    },
    ['hotel.territory']: function () {
      if (!this.hotel.territory) {
        this.data.locations = []
        return
      }

      if (this.$route.params.id === 'add') {
        this.hotel.location = null
      }
      getLocationsTerritoriesAll('', this.hotel.territory)
          .then(res => this.data.locations = res.sort((a, b) => a.names.EN > b.names.EN ? 1 : -1))
    },
    ['hotel.location']: function () {
      if (!this.hotel.location) {
        this.data.areas = []
        return
      }

      if (this.$route.params.id === 'add') {
        this.hotel.area = null
      }
      getAreasLocaitonAll('', this.hotel.location)
          .then(res => this.data.areas = res.sort((a, b) => a.names.EN > b.names.EN ? 1 : -1))
    },
    ['hotel.parkId']: {
      handler() {
        this.selectedPark = this.parks.find((park) => park.id === this.hotel.parkId);
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.page-hotel-title {
  max-width: 66rem;
}

.hotel-status-controls {
  display: flex;
  align-items: center;
  gap: 24px;

  .switch {
    margin-top: 0;
  }
}

.hotel-best-price-control,
.hotel-low-priority-control {
  gap: 10px;
}

.hotel-best-price-badge,
.hotel-low-priority-badge {
  display: block;
  width: 57px;
  height: 14px;
  flex: none;
}

.hotel-location {
  font-size: 12px;

  &__switch-wrapper {
    display: flex;
    align-items: center;
    max-width: 430px;
    justify-content: space-between;
    margin: 15px 0;
    position: relative;
  }

  &__select-wrapper {
    margin: 12px 0;
  }
  &__switch-container {
    display: flex;
    align-items: center;
    gap: 10px;

    & span {
      display: flex;
      justify-content: center;
      min-width: 22px;
    }
  }
  &__title {
    font-weight: 600;
    text-transform: uppercase;
  }
  &__sub-label {
    font-weight: 500;
  }

  &--selected-side {
    font-weight: 700;
  }

  &__alert-text {
    display: flex;
    align-items: center;
    color: #EE4949;
    position: absolute;
    right: -220px;
    width: 150px;
  }
  &__alert {
  }
  &__alert-icon {
    font-size: 36px;
    margin-right: 8px;
  }
}
.hotel-cancellation {
  &__wrapper {
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 25px;
  }

  &__fields {
    display: flex;
    flex-direction: column;
  }

  &__labels {
    display: grid;
    grid-template-columns: 250px 100px 250px;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }

  &__inputs {
    display: grid;
    grid-template-columns: 250px 100px 250px 30px;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }

  &__label {
    font-size: 12px;
    font-weight: 500;
    text-transform: capitalize;
  }

  &__add {
    width: 130px;
  }
}
.hotels__coordinates {
  display: flex;
  gap: 60px;

  & > div {
    flex-grow: 1;
  }
}

.line-cols_geo {
  flex-wrap: nowrap;
  margin-right: -10px;

  & > .form-control-group {
    flex: 1 1 0;
    min-width: 0;
  }

  .select-wrapper,
  .select-trigger {
    width: 100%;
  }
}

@media (max-width: 767px) {
  .line-cols_geo {
    flex-wrap: wrap;

    & > .form-control-group {
      flex-basis: 50%;
    }
  }
}
.hotel-switch {
  font-size: 12px;

  &__wrapper {
    display: flex;
    align-items: center;
    max-width: 430px;
    justify-content: space-between;
    margin: 15px 0;
    position: relative;
  }

  &__select-wrapper {
    margin: 12px 0;
  }
  &__container {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;

    & span {
      display: flex;
      justify-content: center;
      min-width: 22px;
    }
  }
  &__title {
    font-size: 12px;
  }
  &__sub-label {
    font-weight: 500;
  }

  &--selected-side {
    font-weight: 700;
  }

  &__alert-text {
    display: flex;
    align-items: center;
    color: #EE4949;
    position: absolute;
    right: -220px;
    width: 150px;
  }
  &__alert {
  }
  &__alert-icon {
    font-size: 36px;
    margin-right: 8px;
  }
}
</style>
